import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekOfYear from 'dayjs/plugin/weekOfYear';

// Central dayjs configuration. Always import dayjs from here ('utils/dayjs'),
// never directly from 'dayjs' - a bare import gets an unconfigured instance
// where week helpers are missing and the week starts on Sunday.

dayjs.extend(weekOfYear); // .week() getter/setter
dayjs.extend(isoWeek); // .isoWeek(), startOf('isoWeek'), and the W/WW tokens
dayjs.extend(advancedFormat); // W, WW, Q format tokens (W/WW also need isoWeek)
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(updateLocale);

// Reproduces moment.updateLocale('en', { week: { dow: 1 } }) exactly.
// moment shallow-merges dow:1 onto the base en config {dow:0, doy:6}, so the
// effective config is {dow:1, doy:6} - meaning "week 1 is the week containing
// January 2" (this is not ISO-8601, which would be doy:4).
// dayjs expresses the same anchor as yearStart, where yearStart = 7 + dow - doy = 2.
// Dropping yearStart changes .week() on 1113 of 7671 days (14.5%) - whole years
// shift by one week whenever January 1 falls on a Sunday. Do not "simplify" this.
dayjs.updateLocale('en', { weekStart: 1, yearStart: 2 });

export default dayjs;
